var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wp"},[_c('a',{staticClass:"dw",attrs:{"href":"https://www.fitapp.cn/checkClient.html?f=fit"}},[_vm._v("打开APP")])])}]

export { render, staticRenderFns }